import React from 'react';
import pluralize from 'pluralize';
import { Folder, AudioFile } from '../../types';
import { formatFileSize } from '../../utils/formatters';
import { MusicNoteIcon } from '../../icons';
import StatCard from '../ui/StatCard';
import FolderHeader from './FolderHeader';

interface FolderViewProps {
  folder: Folder;
  files: AudioFile[];
}

const FolderView: React.FC<FolderViewProps> = ({ folder, files }) => {
  return (
    <div className="space-y-6">
      {/* Folder Header */}
      <FolderHeader folder={folder} />

      {/* Folder Statistics */}
      <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-6">
        <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100 mb-4">
          Folder Details
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <StatCard value={folder.fileCount || 0} label="Audio Files" />
          <StatCard
            value={
              (folder.fileCount || 0) > 0 && (folder.totalSize || 0) > 0
                ? formatFileSize(folder.totalSize || 0)
                : '—'
            }
            label="Total Size"
          />
          <StatCard value={folder.transcribedCount || 0} label="Transcribed" />
        </div>
      </div>

      {/* Folder Content */}
      {files.length > 0 ? (
        <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-6">
          <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100 mb-4">
            Files in this Folder
          </h3>
          <div className="text-center py-8">
            <p className="text-gray-500">
              {pluralize('file', files.length, true)} in this folder. Select a
              file from the sidebar to view transcript and tools.
            </p>
          </div>
        </div>
      ) : (
        <div className="bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-6">
          <div className="text-center py-8">
            <MusicNoteIcon size={48} className="mx-auto text-gray-400" />
            <h3 className="mt-2 text-sm font-medium text-gray-900 dark:text-gray-100">
              No audio files
            </h3>
            <p className="mt-1 text-sm text-gray-500">
              Get started by uploading an audio file to this folder.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default FolderView;
